import React, {useEffect, useState} from 'react';
import {
    Button,
    Card,
    Flex,
    FloatButton,
    Form,
    Input,
    Menu, MenuProps,
    message,
    Modal,
    Table,
    Tabs,
    Typography,
    UploadFile, UploadProps, Upload, Tag, Tree, TreeProps, Cascader, Segmented
} from "antd";
import ImgCrop from "antd-img-crop";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";
import {PlusOutlined, ReloadOutlined} from "@ant-design/icons";


const Commodity_list_UI = () => {

    document.title='商品列表'
    const navigate = useNavigate();

    let data_time = dayjs().unix();


    const [fetch_spu_info_data_source, setfetch_spu_info_data_source] = useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "3",
                "uuid": "100003",
                "name": "Dell XPS 13",
                "description": "高性能轻薄笔记本电脑，适合商务办公和娱乐",
                "category_id": "2",
                "brand_id": "3",
                "sort_shop_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                "status": "1",
                "status_type": "下架",
                "buy_it_now": "600",
                "image_card_img": "https://myupdat.leytcn.com/upload/1726199774_Untitled-3.jpg",
                image_card_all_json:[],
                "region_id": "6666",
                "created": "1",
                "node_value": null,
                "updated": "1732779731",
                "created_at": "2024-10-24 14:29:00",
                "updated_at": "2024-11-28 15:42:11",
                "country_code": "56888"
            },

        ]
    });


    const [fetch_spu_info_data_source_zaishou, setfetch_spu_info_data_source_zaishou] = useState([{
        key: 'key', name: '666', value: 'value', created: 'created', select: 'select', children: [{
            key: 'dd', name: <div>sku
            </div>
        }]
    }]);

    useEffect(() => {
        window.scrollTo(0, 0); // 每次页面加载时将滚动条位置重置到顶部

        setfetch_spu_info_select_log({message: 'dd', value: '', time: data_time})

    }, []);

    const [fetch_spu_info_select_info, setfetch_spu_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_spu_info_select_log, setfetch_spu_info_select_log] = useState({message: '', value: '', time: 0})
    const fetch_spu_info = (e1: any) => {

        setfetch_spu_info_select_log({message: 'click', value: '', time: data_time})


        setfetch_spu_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_fetch_spu_info, setreturn_data_fetch_spu_info] = useState({});

    const fetch_spu_info_body = new FormData();


    fetch_spu_info_body.append('id', fetch_spu_info_select_info.value1);

    fetch_spu_info_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_spu_info_body.append('time', String(fetch_spu_info_select_info.time));

    fetch_spu_info_body.append('action', 'fetch_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/fetch/fetch_spu.php', {


                method: 'POST',
                body: fetch_spu_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_spu_info(return_data);


                    setfetch_spu_info_data_source(return_data)

                    //    setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break


            }

        }


        if (fetch_spu_info_select_log.message !== '') {

            data_async();
            setfetch_spu_info_select_log({message: '', value: '', time: 0})
        }
    }, [fetch_spu_info_select_log]);


    const [add_products_modal_open, setadd_products_modal_open] = useState(false)

    const [add_products_select_info, setadd_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [add_products_select_log, setadd_products_select_log] = useState({message: '', value: '', time: 0})
    const add_products = (e1: any) => {



        setFileList_add_send_image_image_info([])
        setadd_products_select_log({message: 'click', value: '', time: data_time})

        setadd_products_modal_open(true);

        setadd_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setadd_products_modal_oncancel = () => {

        setadd_products_modal_open(false);
    }


    const [add_products_modal_form] = Form.useForm();

    const add_products_modal_initialValues = {}

    const [add_products_modal_onfinish_select_log, setadd_products_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})

    const [add_products_modal_onfinish_select_info, setadd_products_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0});

    const add_products_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setadd_products_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setadd_products_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [data_sub_add_send_image_image_info, setdata_sub_add_send_image_image_info] = useState([{uid: '', name: '', status: '', response: '', url: ''}])


    const [fetch_data_products_select_info, setfetch_data_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [return_data_add_products, setreturn_data_add_products] = useState({});

    const add_products_body = new FormData();


    add_products_body.append('finish_data', JSON.stringify(add_products_modal_onfinish_select_info.value1));

    add_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    add_products_body.append('time', String(add_products_modal_onfinish_select_info.time));

    add_products_body.append('action', 'addNode');
    add_products_body.append('add_images_info', JSON.stringify(data_sub_add_send_image_image_info))


    add_products_body.append('uuid', fetch_data_products_select_info.value1)


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/insert/insert_spu_p.php', {


                method: 'POST',
                body: add_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setadd_products_modal_open(false)

                    setreturn_data_add_products(return_data);
                    setfetch_spu_info_select_log({message: 'dd', value: '', time: data_time})
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    //   setfetch_data_products_select_log({message:'添加成功',value:'',time:data_time})


                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/admin_login')


                    break


            }

        }


        if (add_products_modal_onfinish_select_log.message !== '') {

            data_async();
            setadd_products_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [add_products_modal_onfinish_select_log]);


    const [fileList_add_send_image_image_info, setFileList_add_send_image_image_info] = useState<UploadFile[]>([]);


    const onChange_add_send_image_image_info: UploadProps['onChange'] = ({fileList: newFileList}) => {
        setFileList_add_send_image_image_info(newFileList);


        console.log({data: newFileList})


        const allDone = newFileList.every(file => file.status === 'done');

        if (allDone) {
            console.log('All files are uploaded successfully:', newFileList);
            let data_time = dayjs().unix();


            setdata_sub_add_send_image_image_info([]);
            newFileList.map(item => {


                console.log('Upload completed:', {type: 'image', info: item.response.url});

                const data_jj = [{type: 'image', value: item.response.url}]

                setdata_sub_add_send_image_image_info(prevDataValue => [
                    ...prevDataValue,
                    {uid: item.uid, status: 'done', name: item.name, response: item.response, url: item.response.url}
                ])

            })


            //    setget_data({ message:'1',value:'',time:data_time});
        }


        console.log('Updated file list:', {value: newFileList});


    };


    const [edit_products_modal_open, setedit_products_modal_open] = useState(false)

    const [edit_products_select_info, setedit_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [edit_products_select_log, setedit_products_select_log] = useState({message: '', value: '', time: 0})
    const edit_products = (e1: any) => {

        console.log({dd: e1})

        edit_products_modal_form.setFieldValue('name', '')
        edit_products_modal_form.setFieldValue('description', '')
        edit_products_modal_form.setFieldValue('buy_it_now', '')
        edit_products_modal_form.setFieldValue('node_value', '')


        fetch_spu_info_data_source.info.filter(filter_item1=>filter_item1.uuid===e1).map(item1=>(

            edit_products_modal_form.setFieldValue('name', item1.name),
        edit_products_modal_form.setFieldValue('description', item1.description),
        edit_products_modal_form.setFieldValue('buy_it_now', item1.buy_it_now),
        edit_products_modal_form.setFieldValue('node_value', item1.node_value),

                setFileList_add_send_image_image_info([]),

                setdata_sub_add_send_image_image_info(item1.image_card_all_json!==null?item1.image_card_all_json:[]),


                edit_products_modal_form.setFieldValue('edit_image_info',item1.image_card_all_json!==null?item1.image_card_all_json:[])
                ,

                setFileList_add_send_image_image_info(item1.image_card_all_json!==null?item1.image_card_all_json:[])

              /*  {item1.image_card_all_json!==null?<div></div>:<div></div>}*/

  /*
      }*/

/*        edit_products_modal_form.setFieldValue('node_value', item1.node_value),*/
    ))


        setedit_products_select_log({message: 'click', value: '', time: data_time})

        setedit_products_modal_open(true);

        setedit_products_select_info({value1: e1, value2: '', value3: '', time: data_time})


      //  setfetch_spu_info_select_log({message: 'dd', value: '', time: data_time})

    }


    const setedit_products_modal_oncancel = () => {

        setedit_products_modal_open(false);
    }


    const [edit_products_modal_form] = Form.useForm();

    const edit_products_modal_initialValues = {}

    const [edit_products_modal_onfinish_select_log, setedit_products_modal_onfinish_select_log] = useState({message: '', value: '', time: 0})

    const [edit_products_modal_onfinish_select_info, setedit_products_modal_onfinish_select_info] = useState({value1: '', value2: '', value3: '', time: 0});

    const edit_products_modal_onfinish = (e1: any) => {

        let data_time = dayjs().unix();

        setedit_products_modal_onfinish_select_log({message: 'next_button', value: '', time: data_time})
        setedit_products_modal_onfinish_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_edit_products, setreturn_data_edit_products] = useState({});

    const edit_products_body = new FormData();


    edit_products_body.append('uuid', edit_products_select_info.value1);

    edit_products_body.append('edit_images_info', JSON.stringify(data_sub_add_send_image_image_info))

    edit_products_body.append('finish_data', JSON.stringify(edit_products_modal_onfinish_select_info.value1));

    edit_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    edit_products_body.append('time', String(edit_products_modal_onfinish_select_info.time));

    edit_products_body.append('action', 'update');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/update/update_spu_p.php', {


                method: 'POST',
                body: edit_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                  /*  message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setedit_products_modal_open(false)

                    setreturn_data_edit_products(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})


                    setfetch_spu_info_select_log({message: 'dd', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/admin_login')


                    break


            }

        }


        if (edit_products_modal_onfinish_select_log.message !== '') {

            data_async();
            setedit_products_modal_onfinish_select_log({message: '', value: '', time: 0})
        }
    }, [edit_products_modal_onfinish_select_log]);


    const [del_products_modal_open, setdel_products_modal_open] = useState(false)

    const [del_products_select_info, setdel_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [del_products_select_log, setdel_products_select_log] = useState({message: '', value: '', time: 0})
    const del_products = (e1: any) => {

        setdel_products_select_log({message: 'click', value: '', time: data_time})

        setdel_products_modal_open(true);

        setdel_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setdel_products_modal_oncancel = () => {

        setdel_products_modal_open(false);
    }


    const [del_products_modal_next_button_select_log, setdel_products_modal_next_button_select_log] = useState({message: '', value: '', time: 0})

    const del_products_modal_next_button = () => {

        let data_time = dayjs().unix();

        setdel_products_modal_next_button_select_log({message: 'next_button', value: '', time: data_time})

    }


    const [return_data_del_products, setreturn_data_del_products] = useState({});

    const del_products_body = new FormData();


    del_products_body.append('uuid', del_products_select_info.value1);

    del_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    del_products_body.append('time', String(del_products_modal_next_button_select_log.time));

    del_products_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/delete/delete_spu_p.php', {


                method: 'POST',
                body: del_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setdel_products_modal_open(false)

                    setreturn_data_del_products(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_spu_info_select_log({message: '删除成功', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/admin_login')


                    break


            }

        }


        if (del_products_modal_next_button_select_log.message !== '') {

            data_async();
            setdel_products_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [del_products_modal_next_button_select_log]);


    const [de_spu_products_modal_open, setde_spu_products_modal_open] = useState(false)

    const [de_spu_products_select_info, setde_spu_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [de_spu_products_select_log, setde_spu_products_select_log] = useState({message: '', value: '', time: 0})
    const de_spu_products = (e1: any) => {

        setde_spu_products_select_log({message: 'click', value: '', time: data_time})

        setde_spu_products_modal_open(true);

        setde_spu_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setde_spu_products_modal_oncancel = () => {

        setde_spu_products_modal_open(false);
    }


    const [de_spu_products_modal_next_button_select_log, setde_spu_products_modal_next_button_select_log] = useState({message: '', value: '', time: 0})

    const de_spu_products_modal_next_button = () => {

        let data_time = dayjs().unix();

        setde_spu_products_modal_next_button_select_log({message: 'next_button', value: '', time: data_time})

    }


    const [return_data_de_spu_products, setreturn_data_de_spu_products] = useState({});

    const de_spu_products_body = new FormData();


    de_spu_products_body.append('uuid', de_spu_products_select_info.value1);

    de_spu_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    de_spu_products_body.append('time', String(de_spu_products_modal_next_button_select_log.time));


    de_spu_products_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/despu/despu_spu_p.php', {


                method: 'POST',
                body: de_spu_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    /*message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setde_spu_products_modal_open(false)

                    setreturn_data_de_spu_products(return_data);
                    setfetch_spu_info_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

            }

        }


        if (de_spu_products_modal_next_button_select_log.message !== '') {

            data_async();
            setde_spu_products_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [de_spu_products_modal_next_button_select_log]);


    const [en_spu_products_modal_open, seten_spu_products_modal_open] = useState(false)

    const [en_spu_products_select_info, seten_spu_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [en_spu_products_select_log, seten_spu_products_select_log] = useState({message: '', value: '', time: 0})
    const en_spu_products = (e1: any) => {

        seten_spu_products_select_log({message: 'click', value: '', time: data_time})

        seten_spu_products_modal_open(true);

        seten_spu_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const seten_spu_products_modal_oncancel = () => {

        seten_spu_products_modal_open(false);
    }


    const [en_spu_products_modal_next_button_select_log, seten_spu_products_modal_next_button_select_log] = useState({message: '', value: '', time: 0})

    const en_spu_products_modal_next_button = () => {

        let data_time = dayjs().unix();

        seten_spu_products_modal_next_button_select_log({message: 'next_button', value: '', time: data_time})

    }


    const [return_data_en_spu_products, setreturn_data_en_spu_products] = useState({});

    const en_spu_products_body = new FormData();


    en_spu_products_body.append('uuid', en_spu_products_select_info.value1);

    en_spu_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    en_spu_products_body.append('time', String(en_spu_products_modal_next_button_select_log.time));

    en_spu_products_body.append('action', 'del_node');


    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/enspu/enspu_spu_p.php', {


                method: 'POST',
                body: en_spu_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    seten_spu_products_modal_open(false)

                    setreturn_data_en_spu_products(return_data);
                    setfetch_spu_info_select_log({message: '删除成功', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

            }

        }


        if (en_spu_products_modal_next_button_select_log.message !== '') {

            data_async();
            seten_spu_products_modal_next_button_select_log({message: '', value: '', time: 0})
        }
    }, [en_spu_products_modal_next_button_select_log]);




    const [remove_spu_products_modal_open, setremove_spu_products_modal_open] = useState(false)

    const [remove_spu_products_select_info, setremove_spu_products_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [remove_spu_products_select_log, setremove_spu_products_select_log] = useState({message: '', value: '', time: 0})
    const remove_spu_products = (e1: any) => {

        setremove_spu_products_select_log({message: 'click', value: '', time: data_time})

        setremove_spu_products_modal_open(true);

        setremove_spu_products_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setremove_spu_products_modal_oncancel = () => {

        setremove_spu_products_modal_open(false);
    }


    const [remove_spu_products_modal_form]=Form.useForm();

    const remove_spu_products_modal_initialValues={




    }

    const [remove_spu_products_modal_onfinish_select_log,setremove_spu_products_modal_onfinish_select_log]=useState({message:'',value:'',time:0})

    const [remove_spu_products_modal_onfinish_select_info,setremove_spu_products_modal_onfinish_select_info]=useState({value1:'',value2:'',value3:'',time:0});

    const remove_spu_products_modal_onfinish = (e1:any) => {

        let data_time=dayjs().unix();

        setremove_spu_products_modal_onfinish_select_log({message:'next_button',value:'',time:data_time})
        setremove_spu_products_modal_onfinish_select_info({value1:e1,value2:'',value3:'',time:data_time})
    }


    const [return_data_remove_spu_products,setreturn_data_remove_spu_products]=useState({});

    const remove_spu_products_body = new FormData();

    remove_spu_products_body.append('uuid', remove_spu_products_select_info.value1);

    remove_spu_products_body.append('finish_data', JSON.stringify(remove_spu_products_modal_onfinish_select_info.value1));

    remove_spu_products_body.append('userToken', String(Cookies.get('userToken_chattool')));

    remove_spu_products_body.append('time', String(remove_spu_products_modal_onfinish_select_info.time));

    remove_spu_products_body.append('action', 'update');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/update/update_spu_sort_map.php', {


                method: 'POST',
                body: remove_spu_products_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                   /* message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setremove_spu_products_modal_open(false)

                    setreturn_data_remove_spu_products(return_data);
                    //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})
                    setfetch_spu_info_select_log({message: 'dd', value: '', time: data_time})
                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break


            }

        }


        if(remove_spu_products_modal_onfinish_select_log.message!==''){

            data_async();
            setremove_spu_products_modal_onfinish_select_log({message:'',value:'',time:0})
        }
    }, [remove_spu_products_modal_onfinish_select_log]);



    const tree_click_d =(e1:any)=>{


        console.log({click:e1})


    }


    const tree_select_d =(e1:any)=>{


        console.log({select:e1})


    }


    useEffect(() => {



        setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})


    }, []);



    const [fetch_sort_shop_select_info, setfetch_sort_shop_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [fetch_sort_shop_select_log, setfetch_sort_shop_select_log] = useState({message: '', value: '', time: 0})
    const fetch_sort_shop = (e1: any) => {

        setfetch_sort_shop_select_log({message: 'click', value: '', time: data_time})



        setfetch_sort_shop_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }

    const [table_date_s,settable_date_s]=useState([
        {
            'key':'1',
            "name": "健康保健",
            "label": "健康保健",
            "children": [
                {
                    'key':'2',
                    "name": "桶装",
                    "label": "桶装",
                    "children": [
                        {
                            'key':'3',
                            "name": "12",
                            "label": "12"
                        }
                    ]
                }

            ]
        }
    ])

    const [return_data_fetch_sort_shop,setreturn_data_fetch_sort_shop]=useState({
        "message": 0,
        "value": "获取成功",
        "info": [
            {
                "id": "2",
                "uuid": "93386a13-82a4-4937-a7a2-1a3762c7206c",
                "userid": null,
                "sort_name": "健康保健",
                "created": null,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999",
                "children": []
            },
            {
                "id": "3",
                "uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                "userid": null,
                "sort_name": "桶装",
                "created": null,
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": "6666",
                "row_num": "999",
                "children": [
                    {
                        "id": "4",
                        "uuid": "3c67f228-d947-449a-a2e3-9cedf27da004",
                        "userid": null,
                        "sort_name": "12",
                        "created": "1729152105",
                        "status": "en",
                        "updated": null,
                        "parent_uuid": "1bfbb104-f8b2-4924-be31-c8c52992a415",
                        "country_code": "56888",
                        "region_parent_id": null,
                        "region_id": null,
                        "row_num": "999",
                        "children": []
                    }
                ]
            },
            {
                "id": "5",
                "uuid": "9a8dcd62-dc4c-415c-8b11-a3efd4494ebd",
                "userid": null,
                "sort_name": "11",
                "created": "1729152355",
                "status": "en",
                "updated": null,
                "parent_uuid": "0",
                "country_code": "56888",
                "region_parent_id": null,
                "region_id": null,
                "row_num": "999",
                "children": []
            }
        ]
    });

    const fetch_sort_shop_body = new FormData();


    fetch_sort_shop_body.append('id', fetch_sort_shop_select_info.value1);

    fetch_sort_shop_body.append('userToken', String(Cookies.get('userToken_chattool')));

    fetch_sort_shop_body.append('time', String(fetch_sort_shop_select_info.time));

    fetch_sort_shop_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/sort_shop/fetch/fetch_sort_shop.php', {


                method: 'POST',
                body: fetch_sort_shop_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_fetch_sort_shop(return_data);

                    //  setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break


            }

        }


        if(fetch_sort_shop_select_log.message!==''){

            data_async();
            setfetch_sort_shop_select_log({message:'',value:'',time:0})
        }
    }, [fetch_sort_shop_select_log]);



    const onchange_cascader_d=(e1:any)=>{


        console.log({e1:e1})

        if(e1===undefined){



            setfetch_spu_info_select_log({message:'1',value:'',time:data_time})


        }else{





        setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})



        setfilter_spu_sort_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})

        }
    }






    const [filter_spu_sort_uuid_select_info, setfilter_spu_sort_uuid_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [filter_spu_sort_uuid_select_log, setfilter_spu_sort_uuid_select_log] = useState({message: '', value: '', time: 0})
    const filter_spu_sort_uuid = (e1: any) => {

        setfilter_spu_sort_uuid_select_log({message: 'click', value: '', time: data_time})



        setfilter_spu_sort_uuid_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_filter_spu_sort_uuid,setreturn_data_filter_spu_sort_uuid]=useState({});

    const filter_spu_sort_uuid_body = new FormData();


    filter_spu_sort_uuid_body.append('cascader_uuid', JSON.stringify(filter_spu_sort_uuid_select_info.value1));

    filter_spu_sort_uuid_body.append('userToken', String(Cookies.get('userToken_chattool')));

    filter_spu_sort_uuid_body.append('time', String(filter_spu_sort_uuid_select_info.time));

    filter_spu_sort_uuid_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/filter/filter_spu.php', {


                method: 'POST',
                body: filter_spu_sort_uuid_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_filter_spu_sort_uuid(return_data);
                    setfetch_spu_info_data_source(return_data);
                    //            setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/admin/commodity_list')


                    break


            }

        }


        if(filter_spu_sort_uuid_select_log.message!==''){

            data_async();
            setfilter_spu_sort_uuid_select_log({message:'',value:'',time:0})
        }
    }, [filter_spu_sort_uuid_select_log]);




    const cancel_filter_spu=()=>{


        setfetch_spu_info_select_log({message:'1',value:'',time:data_time})

    }





    const [permanently_del_commodity_modal_open, setpermanently_del_commodity_modal_open] = useState(false)

    const [permanently_del_commodity_select_info, setpermanently_del_commodity_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [permanently_del_commodity_select_log, setpermanently_del_commodity_select_log] = useState({message: '', value: '', time: 0})
    const permanently_del_commodity = (e1: any) => {

        setpermanently_del_commodity_select_log({message: 'click', value: '', time: data_time})

        setpermanently_del_commodity_modal_open(true);

        setpermanently_del_commodity_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const setpermanently_del_commodity_modal_oncancel = () => {

        setpermanently_del_commodity_modal_open(false);
    }


    const [permanently_del_commodity_modal_next_button_select_log,setpermanently_del_commodity_modal_next_button_select_log]=useState({message:'',value:'',time:0})

    const permanently_del_commodity_modal_next_button = () => {

        let data_time=dayjs().unix();

        setpermanently_del_commodity_modal_next_button_select_log({message:'next_button',value:'',time:data_time})

    }


    const [return_data_permanently_del_commodity,setreturn_data_permanently_del_commodity]=useState({});

    const permanently_del_commodity_body = new FormData();


    permanently_del_commodity_body.append('uuid', permanently_del_commodity_select_info.value1);

    permanently_del_commodity_body.append('userToken', String(Cookies.get('userToken_chattool')));

    permanently_del_commodity_body.append('time', String(permanently_del_commodity_modal_next_button_select_log.time));

    permanently_del_commodity_body.append('action', 'del_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/delete/permanently_del_spu_p.php', {


                method: 'POST',
                body: permanently_del_commodity_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:


                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setpermanently_del_commodity_modal_open(false)

                    setreturn_data_permanently_del_commodity(return_data);
                    setfetch_spu_info_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

            }

        }


        if(permanently_del_commodity_modal_next_button_select_log.message!==''){

            data_async();
            setpermanently_del_commodity_modal_next_button_select_log({message:'',value:'',time:0})
        }
    }, [permanently_del_commodity_modal_next_button_select_log]);







    const [filter_spu_nosort_select_info, setfilter_spu_nosort_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [filter_spu_nosort_select_log, setfilter_spu_nosort_select_log] = useState({message: '', value: '', time: 0})
    const filter_spu_nosort = (e1: any) => {

        setfilter_spu_nosort_select_log({message: 'click', value: '', time: data_time})



        setfilter_spu_nosort_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_filter_spu_nosort,setreturn_data_filter_spu_nosort]=useState({});

    const filter_spu_nosort_body = new FormData();


    filter_spu_nosort_body.append('id', filter_spu_nosort_select_info.value1);

    filter_spu_nosort_body.append('userToken', String(Cookies.get('userToken_chattool')));

    filter_spu_nosort_body.append('time', String(filter_spu_nosort_select_info.time));

    filter_spu_nosort_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/admin/spu/filter/filter_spu_nosort.php', {


                method: 'POST',
                body: filter_spu_nosort_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

                    //无需提示
                    //message.success(return_data.value)
                    let data_time = dayjs().unix();

                    setreturn_data_filter_spu_nosort(return_data);
                    setreturn_data_filter_spu_sort_uuid(return_data);
                    setfetch_spu_info_data_source(return_data);
                   // setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/*****/item1')


                    break


            }

        }


        if(filter_spu_nosort_select_log.message!==''){

            data_async();
            setfilter_spu_nosort_select_log({message:'',value:'',time:0})
        }
    }, [filter_spu_nosort_select_log]);


const Segmented_onChange=(e1:any)=>{


  //  setreturn_data_fetch_sort_shop([])
    switch (e1){

        case 'all':
            fetch_spu_info('')

            setCascader_show_status('1')
            /*<Button onClick={fetch_spu_info}>全部</Button>

            <Button onClick={filter_spu_nosort}>未分类</Button>*/

            break;

        case 'nosort':

            setCascader_show_status('0')
            filter_spu_nosort('')

            break;

    }

    console.log(e1)
}


const [Cascader_show_status,setCascader_show_status]=useState('1')

    return (
        <div className="admin-fill-page admin-commodity-list-page">


<Card>



            <div >


{/*

           <label>商品</label>
*/}


            </div>
            <p></p>



    <Segmented onChange={Segmented_onChange}
        options={[
            { label: '全部', value: 'all' },
            { label: '未分类', value: 'nosort' },
        ]}
    />


<p></p>

    {Cascader_show_status==='1'?<div>   筛选分组：
        <p></p>


        <Cascader  style={{width:'100%'}} onChange={onchange_cascader_d} options={return_data_fetch_sort_shop.info.map(item1=>({key:item1.uuid,label:item1.sort_name,value:item1.uuid,children:item1.children.map(item1_children=>({key:item1_children.uuid,label:item1_children.sort_name,value:item1_children.uuid}))}))}/>
    </div>:<div></div>}


         {/*   <Button onClick={cancel_filter_spu} >取消筛选</Button>
            <p></p>*/}

            <Tabs items={[{
                key: '1', label: '全部'+''+fetch_spu_info_data_source.info.length+'', children: <Table
                    scroll={{ x: 'max-content' }}

                    dataSource={fetch_spu_info_data_source.message!==2000?[]:fetch_spu_info_data_source.info.map((item1: any) => ({
                        key: item1.uuid, name: <div style={{display: 'flex'}}>


                            <div>

                                <div style={{flex: 0}}>
                                    <img
                                        style={{
                                            width: '100px',  // 增大图片宽度
                                            objectFit: 'cover',
                                            height: '100px', // 增大图片高度
                                            borderRadius: '4px',  // 可选：让图片有圆角
                                        }}
                                        src={item1.image_card_img}
                                        alt={item1.specifications} // 添加alt属性用于无障碍访问
                                    />
                                </div>

                            </div>

                            <div style={{marginLeft: 15, content: 'contents'}}>

                                {item1.name}
                                <p></p>
                               <label style={{fontSize:'2.5'}}>{item1.description}</label>
                                <p></p>
                                uuid：{item1.uuid}
                            </div>

                        </div>, value: item1.value,description:item1.description,node_value:item1.node_value, status_type: item1.status_type, created: <div>

                            {dayjs.unix(item1.created).format('YYYY-MM-DD HH:mm:ss')}

                            {item1.status_type === '删除' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}

                            {item1.status_type === '下架' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}
                            {item1.status_type === '在售' ?
                                <div><Tag color={'#87d068'}>{item1.status_type}</Tag></div> : <div></div>}

                        </div>, select: '',node:<div>{item1.node_value}</div>
                        ,sort_info:<div>{item1.sort_info}</div>,buy_it_now:<div>¥ {item1.buy_it_now}</div>
                    }))}
                    columns={[{title: '商品名称', dataIndex: 'name', key: 'name'},{title:'价格',dataIndex:'buy_it_now',key:'buy_it_now'},{title: '分类', dataIndex: 'sort_info', key: 'sort_info'}, {title: '创建时间', dataIndex: 'created', key: 'created'},{title: '备注', dataIndex: 'node', key: 'node'}, {
                        title: '操作', dataIndex: 'select', key: 'select', render: (text, record) => (<div>{text}


                            {record.status_type === '在售' ? <Flex gap={'small'} vertical>

                                <a onClick={() => edit_products(record.key)}>编辑商品</a>
                                <a onClick={() => del_products(record.key)}>删除商品</a>

                               <a onClick={() => de_spu_products(record.key)}>下架商品</a>

                                <a onClick={() => remove_spu_products(record.key)}>移动商品</a>

                              {/*  {record.status_type === '在售' ?
                                    <></>}
                                {record.status_type === '下架' ?
                                    <div><a onClick={() => en_spu_products(record.key)}>上架商品</a></div> :
                                    <></>}
                              */}

                                <a onClick={()=>navigate('/admin/detail?product_uuid='+record.key)} >商品知识</a>
                            </Flex>:<div></div>}



                            {record.status_type === '下架' ? <Flex gap={'small'} vertical>

                                    <a onClick={() => del_products(record.key)}>删除商品</a>


                          <a onClick={() => en_spu_products(record.key)}>上架商品</a>


                                </Flex>
                                :<div></div>}


                            {record.status_type === '删除' ? <Flex gap={'small'} vertical>



                                <div>    <a onClick={() => permanently_del_commodity(record.key)}>永久删除</a></div>

                                <a onClick={() => en_spu_products(record.key)}>恢复上架</a>


                                <div><a onClick={() => de_spu_products(record.key)}>放回仓库</a></div>



                            </Flex>:<div></div>}

                     {/*       <Flex gap={'small'} vertical>

                                <a onClick={() => edit_products(record.key)}>编辑商品</a>
                                <a onClick={() => del_products(record.key)}>删除商品</a>



                                {record.status_type === '在售' ?
                                    <div><a onClick={() => de_spu_products(record.key)}>下架商品</a></div> :
                                    <></>}
                                {record.status_type === '下架' ?
                                    <div><a onClick={() => en_spu_products(record.key)}>上架商品</a></div> :
                                    <></>}
                                <a onClick={() => remove_spu_products(record.key)}>移动商品</a>


                                <a onClick={()=>navigate('/admin/detail?product_uuid='+record.key)} >商品知识</a>
                            </Flex>*/}


                        </div>)
                    }]}/>

            }, {
                key: '2', label: '出售'+''+fetch_spu_info_data_source.info.filter((item1_filter: any) => item1_filter.status_type === '在售').length+'', children: <Table
                    scroll={{ x: 'max-content' }}
                    dataSource={fetch_spu_info_data_source.info.filter((item1_filter: any) => item1_filter.status_type === '在售').map((item1: any) => ({
                        key: item1.uuid, name: <div style={{display: 'flex'}}>


                            <div>

                                <div style={{flex: 0}}>
                                    <img
                                        style={{
                                            width: '100px',  // 增大图片宽度
                                            objectFit: 'cover',
                                            height: '100px', // 增大图片高度
                                            borderRadius: '4px',  // 可选：让图片有圆角
                                        }}
                                        src={item1.image_card_img}
                                        alt={item1.specifications} // 添加alt属性用于无障碍访问
                                    />
                                </div>

                            </div>

                            <div style={{marginLeft: 15, content: 'contents'}}>

                                {item1.name}
                                <p></p>
                                <label style={{fontSize:'2.5'}}>{item1.description}</label>
                                <p></p>
                                uuid：{item1.uuid}
                            </div>

                        </div>, value: item1.value,description:item1.description,node_value:item1.node_value, status_type: item1.status_type, created: <div>

                        {dayjs.unix(item1.created).format('YYYY-MM-DD HH:mm:ss')}

                            {item1.status_type === '删除' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}

                            {item1.status_type === '下架' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}
                            {item1.status_type === '在售' ?
                                <div><Tag color={'#87d068'}>{item1.status_type}</Tag></div> : <div></div>}

                        </div>, select: '',node:<div>{item1.node_value}</div>
                        ,sort_info:<div>{item1.sort_info}</div>,buy_it_now:<div>¥ {item1.buy_it_now}</div>
                    }))}
                    columns={[{title: '商品名称', dataIndex: 'name', key: 'name'},{title:'价格',dataIndex:'buy_it_now',key:'buy_it_now'},{title: '分类', dataIndex: 'sort_info', key: 'sort_info'}, {title: '创建时间', dataIndex: 'created', key: 'created'},{title: '备注', dataIndex: 'node', key: 'node'}, {
                        title: '操作', dataIndex: 'select', key: 'select', render: (text, record) => (<div>{text}


                            {record.status_type === '在售' ? <Flex gap={'small'} vertical>

                                <a onClick={() => edit_products(record.key)}>编辑商品</a>
                                <a onClick={() => del_products(record.key)}>删除商品</a>

                                <a onClick={() => de_spu_products(record.key)}>下架商品</a>

                                <a onClick={() => remove_spu_products(record.key)}>移动商品</a>

                                {/*  {record.status_type === '在售' ?
                                    <></>}
                                {record.status_type === '下架' ?
                                    <div><a onClick={() => en_spu_products(record.key)}>上架商品</a></div> :
                                    <></>}
                              */}

                                <a onClick={()=>navigate('/admin/detail?product_uuid='+record.key)} >商品知识</a>
                            </Flex>:<div></div>}



                        </div>)
                    }]}/>
            }, {key: '3', label: '仓库'+''+fetch_spu_info_data_source.info.filter((item1_filter: any) => item1_filter.status_type === '下架').length+'', children:<Table
                    scroll={{ x: 'max-content' }}

                    dataSource={fetch_spu_info_data_source.info.filter((item1_filter: any) => item1_filter.status_type === '下架').map((item1: any) => ({
                        key: item1.uuid, name: <div style={{display: 'flex'}}>


                            <div>

                                <div style={{flex: 0}}>
                                    <img
                                        style={{
                                            width: '100px',  // 增大图片宽度
                                            objectFit: 'cover',
                                            height: '100px', // 增大图片高度
                                            borderRadius: '4px',  // 可选：让图片有圆角
                                        }}
                                        src={item1.image_card_img}
                                        alt={item1.specifications} // 添加alt属性用于无障碍访问
                                    />
                                </div>

                            </div>

                            <div style={{marginLeft: 15, content: 'contents'}}>

                                {item1.name}
                                <p></p>
                                <label style={{fontSize:'2.5'}}>{item1.description}</label>
                                <p></p>
                                uuid：{item1.uuid}
                            </div>

                        </div>, value: item1.value,description:item1.description,node_value:item1.node_value, status_type: item1.status_type, created: <div>

                        {dayjs.unix(item1.created).format('YYYY-MM-DD HH:mm:ss')}

                            {item1.status_type === '删除' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}

                            {item1.status_type === '下架' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}
                            {item1.status_type === '在售' ?
                                <div><Tag color={'#87d068'}>{item1.status_type}</Tag></div> : <div></div>}

                        </div>, select: '',node:<div>{item1.node_value}</div>
                        ,sort_info:<div>{item1.sort_info}</div>,buy_it_now:<div>¥ {item1.buy_it_now}</div>
                    }))}
                    columns={[{title: '商品名称', dataIndex: 'name', key: 'name'},{title:'价格',dataIndex:'buy_it_now',key:'buy_it_now'},{title: '分类', dataIndex: 'sort_info', key: 'sort_info'}, {title: '创建时间', dataIndex: 'created', key: 'created'},{title: '备注', dataIndex: 'node', key: 'node'}, {
                        title: '操作', dataIndex: 'select', key: 'select', render: (text, record) => (<div>{text}


                            {record.status_type === '下架' ? <Flex gap={'small'} vertical>

                                    <a onClick={() => del_products(record.key)}>删除商品</a>


                                    <a onClick={() => en_spu_products(record.key)}>上架商品</a>


                                </Flex>
                                :<div></div>}



                        </div>)
                    }]}/>}, {
                key: '4', label: '回收'+''+fetch_spu_info_data_source.info.filter((item1_filter: any) => item1_filter.status_type === '删除').length+'', children: <Table
                    scroll={{ x: 'max-content' }}

                    dataSource={fetch_spu_info_data_source.info.filter((item1_filter: any) => item1_filter.status_type === '删除').map((item1: any) => ({
                        key: item1.uuid, name: <div style={{display: 'flex'}}>


                            <div>

                                <div style={{flex: 0}}>
                                    <img
                                        style={{
                                            width: '100px',  // 增大图片宽度
                                            objectFit: 'cover',
                                            height: '100px', // 增大图片高度
                                            borderRadius: '4px',  // 可选：让图片有圆角
                                        }}
                                        src={item1.image_card_img}
                                        alt={item1.specifications} // 添加alt属性用于无障碍访问
                                    />
                                </div>

                            </div>

                            <div style={{marginLeft: 15, content: 'contents'}}>

                                {item1.name}
                                <p></p>
                                <label style={{fontSize:'2.5'}}>{item1.description}</label>
                                <p></p>
                                uuid：{item1.uuid}
                            </div>

                        </div>, value: item1.value,description:item1.description,node_value:item1.node_value, status_type: item1.status_type, created: <div>

                        {dayjs.unix(item1.created).format('YYYY-MM-DD HH:mm:ss')}

                            {item1.status_type === '删除' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}

                            {item1.status_type === '下架' ? <div><Tag color={'#f50'}>{item1.status_type}</Tag></div> :
                                <div></div>}
                            {item1.status_type === '在售' ?
                                <div><Tag color={'#87d068'}>{item1.status_type}</Tag></div> : <div></div>}

                        </div>, select: '',node:<div>{item1.node_value}</div>
                        ,sort_info:<div>{item1.sort_info}</div>,buy_it_now:<div>¥ {item1.buy_it_now}</div>
                    }))}
                    columns={[{title: '商品名称', dataIndex: 'name', key: 'name'},{title:'价格',dataIndex:'buy_it_now',key:'buy_it_now'},{title: '分类', dataIndex: 'sort_info', key: 'sort_info'}, {title: '创建时间', dataIndex: 'created', key: 'created'},{title: '备注', dataIndex: 'node', key: 'node'}, {
                        title: '操作', dataIndex: 'select', key: 'select', render: (text, record) => (<div>{text}


                            {record.status_type === '删除' ? <Flex gap={'small'} vertical>



                                <div>    <a onClick={() => permanently_del_commodity(record.key)}>永久删除</a></div>

                                <a onClick={() => en_spu_products(record.key)}>恢复上架</a>


                                <div><a onClick={() => de_spu_products(record.key)}>放回仓库</a></div>



                            </Flex>:<div></div>}


                        </div>)
                    }]}/>
            }]}/>




</Card>


            <FloatButton.Group className="admin-float-actions">
                <FloatButton icon={<PlusOutlined/>} tooltip="新增商品" onClick={add_products}/>
                <FloatButton icon={<ReloadOutlined/>} tooltip="刷新" onClick={fetch_spu_info}/>
            </FloatButton.Group>


            <Modal open={del_products_modal_open} onCancel={setdel_products_modal_oncancel} footer={null}
                   title={'是否确认删除'}>


                <Button onClick={del_products_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft: 10}} onClick={setdel_products_modal_oncancel}>

                    取消
                </Button>


            </Modal>





            <Modal open={permanently_del_commodity_modal_open} onCancel={setpermanently_del_commodity_modal_oncancel} footer={null} title={'是否永久删除'}>


                <Button onClick={permanently_del_commodity_modal_next_button}>

                    确认删除
                </Button>


                <Button style={{marginLeft:10}} onClick={setpermanently_del_commodity_modal_oncancel}>

                    取消
                </Button>


            </Modal>





            <Modal open={remove_spu_products_modal_open} onCancel={setremove_spu_products_modal_oncancel} footer={null} title={'移动商品'}>





                <Form form={remove_spu_products_modal_form} initialValues={remove_spu_products_modal_initialValues} onFinish={remove_spu_products_modal_onfinish}>

                    <label>选则位置</label>
                    <p></p>

                    <Form.Item name={'select_map'} rules={[{message:'必填项',required:true}]}>

                        <Cascader  style={{width:'100%'}} options={return_data_fetch_sort_shop.info.map(item1=>({key:item1.uuid,label:item1.sort_name,value:item1.uuid,children:item1.children.map(item1_children=>({key:item1_children.uuid,label:item1_children.sort_name,value:item1_children.uuid}))}))}/>



                    </Form.Item>



                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft:10}} onClick={setremove_spu_products_modal_oncancel}>取消</Button>

                </Form>


            </Modal>





            <Modal open={edit_products_modal_open} onCancel={setedit_products_modal_oncancel} footer={null}
                   title={'修改信息'}>


                <Form form={edit_products_modal_form} initialValues={edit_products_modal_initialValues}
                      onFinish={edit_products_modal_onfinish}>

                    <label>商品</label>

                    <Form.Item name="name" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="商品"/>
                    </Form.Item>

                    <label>描述</label>

                    <Form.Item name="description" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="描述"/>
                    </Form.Item>


                    <label>价格</label>

                    <Form.Item name="buy_it_now" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="价格"/>
                    </Form.Item>

                    <label>备注</label>

                    <Form.Item name="node_value" >
                        <Input placeholder="备注"/>
                    </Form.Item>
                    <Form.Item name="image_value1">
                        <ImgCrop rotationSlider>
                            <Upload
                                action="https://myimg-dh56z2.leytcn.com:8443/upload_file.php"
                                listType="picture-card"
                                fileList={fileList_add_send_image_image_info}
                                onChange={onChange_add_send_image_image_info}

                            >
                                {fileList_add_send_image_image_info.length < 5 && '+ Upload'}
                            </Upload>
                        </ImgCrop>
                    </Form.Item>


                    <Button htmlType={'submit'} type={'primary'}>提交</Button>
                    <Button style={{marginLeft: 10}} onClick={setedit_products_modal_oncancel}>取消</Button>

                </Form>


            </Modal>


            <Modal open={en_spu_products_modal_open} onCancel={seten_spu_products_modal_oncancel} footer={null}
                   title={'是否确认上架'}>


                <Button onClick={en_spu_products_modal_next_button}>
                    上架
                </Button>


                <Button style={{marginLeft: 10}} onClick={seten_spu_products_modal_oncancel}>

                    取消
                </Button>


            </Modal>


            <Modal open={de_spu_products_modal_open} onCancel={setde_spu_products_modal_oncancel} footer={null}
                   title={'是否放回仓库'}>


                <Button onClick={de_spu_products_modal_next_button}>

                    确认
                </Button>


                <Button style={{marginLeft: 10}} onClick={setde_spu_products_modal_oncancel}>

                    取消
                </Button>


            </Modal>


            <Modal open={add_products_modal_open} onCancel={setadd_products_modal_oncancel} width={1000} footer={null}
                   title="商品信息">


                <Form form={add_products_modal_form} initialValues={add_products_modal_initialValues}
                      onFinish={add_products_modal_onfinish}>

                    <h2>基础信息</h2>

                    <p></p>

                    <label>商品</label>
                    <Form.Item name="shop_name" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="商品"/>
                    </Form.Item>


                    <label>子标</label>
                    <Form.Item name="shop_sub_name" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="子标"/>
                    </Form.Item>



                    <p></p>

                    <label>一口价</label>

                    <Form.Item name="buy_it_now" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="一口价"/>
                    </Form.Item>




                    {/*      <label>进货价格</label>

                    <Form.Item name="market_price" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="进货价格"/>
                    </Form.Item>*/}




                    <label>库存</label>

                    <Form.Item name="input_value4" rules={[{message: '必填项', required: true}]}>
                        <Input placeholder="库存"/>
                    </Form.Item>


                    <label>备注</label>

                    <Form.Item name="node_value" >
                        <Input placeholder="备注"/>
                    </Form.Item>

                    <h2>图文描述</h2>

                    <label>主图</label>

                    <Form.Item name="image_value1">


                        <ImgCrop rotationSlider>
                            <Upload
                                action="https://myimg-dh56z2.leytcn.com:8443/upload_file.php"
                                listType="picture-card"
                                fileList={fileList_add_send_image_image_info}
                                onChange={onChange_add_send_image_image_info}

                            >
                                {fileList_add_send_image_image_info.length < 5 && '+ Upload'}
                            </Upload>
                        </ImgCrop>


                    </Form.Item>


                    {/*   <label>宝贝详细</label>
*/}




                   {/* <div style={{display: 'flex'}}>

                        <h2 style={{flexGrow: 1}}>数据表信</h2>       <label>选择模板</label>


                    </div>


                    <Form.Item noStyle shouldUpdate>
                        {() => (
                            <Typography>
                                <pre>{JSON.stringify(add_products_modal_form.getFieldsValue(), null, 2)}</pre>
                            </Typography>
                        )}
                    </Form.Item>

                    <p></p>*/}

                    <Button htmlType="submit" type="primary">提交</Button>

                    <Button style={{marginLeft: 10}} onClick={setadd_products_modal_oncancel}>取消</Button>
                </Form>
            </Modal>
        </div>
    )
}
export default Commodity_list_UI;
